import {configureStore} from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { persistStore, persistReducer } from 'redux-persist';
import { thunk } from 'redux-thunk'
import {loggerMiddleware} from "./middlewares/loggerMiddleware";
import rootReducer from "./rootReducer";
import {encryptTransform} from "redux-persist-transform-encrypt";

const ENABLE_REDUX_DEV_TOOLS = process.env.REACT_APP_RUN_MODE === "dev";

const encryptor = encryptTransform({
    secretKey: 'Super-Secret-key-jrtec',
    onError: function (error) {
        console.log("ERROR ENCRYPTION")
        console.log(error)
    }
})

const persistConfig = {
    key: 'root',
    storage: storage,
    // timeout: null,
    timeout: 60,
    transforms: [encryptor]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    devTools: ENABLE_REDUX_DEV_TOOLS,
    middleware: [thunk]
});


export const persistor = persistStore(store);

/*

export default configureStore({
    reducer: rootReducer,
    // middleware: [loggerMiddleware]
});*/
